export const getScribeById = ({ scribes }, scribeId) =>
  scribes &&
  scribes.allScribes &&
  scribes.allScribes.find(scribe => parseInt(scribe.id, 10) === parseInt(scribeId, 10));

export const getTemplateById = ({ templates }, templateId) => {
  return templates?.templatesByCategory
    .flatMap(category => category.templates)
    .find(template => template.id === templateId);
};

export const getClipboard = ({ scribes }) => scribes.clipboard;
export const getActiveElements = ({ scribes }) => scribes.activeElements;

export const getUndoObjects = ({ scribes }, scribeId) => ({
  activeScribe: getScribeById({ scribes }, scribeId),
  activeScribePast: scribes.activeScribePast,
  activeScribeFuture: scribes.activeScribeFuture
});

export const getLastUnsuccessfulAction = ({ auth }) => auth.lastAction;

export const getToken = state => state.auth && state.auth.currentUser && state.auth.currentUser.token;

export const getContentfulManagementToken = state => state.templates && state.templates.contentfulManagementToken;

export const getUserAccountType = state => state.auth.currentUser?.accountType;

export const getUser = state => state.auth.currentUser;

export const getImageCropData = state => state.cropping.imageCrop;
